App.BannersIndexController = Em.Controller.extend
  needs: [ 'banners' ]
  bannersBinding: 'model'

  actualityBinding:  'controllers.banners.actuality'

  headerTranslateKey: Ember.computed(
    'actuality'
    ->
      actuality = @get('actuality')

      return "banners.headers.index" if Ember.isEmpty(actuality)

      "banners.headers.#{actuality}"
  )

  actions:
    openBanner: (banner) ->
      @transitionToRoute 'banners.banner.edit', banner.get('id')
